/**
 * Static placeholder image as data URI - works in production without external files.
 * Replace with real image URLs when ready.
 */
export const PLACEHOLDER_IMAGE =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"><rect width="400" height="300" fill="#e8e8e8"/><rect x="175" y="120" width="50" height="60" fill="#d0d0d0" rx="2"/><circle cx="200" cy="170" r="12" fill="#c0c0c0"/><path d="M165 200 L200 165 L235 195 L270 160 L270 200 L165 200 Z" fill="#d0d0d0"/></svg>'
  );
